
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categorias/[uid]",
      function () {
        return require("private-next-pages/categorias/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categorias/[uid]"])
      });
    }
  